<template>
  <div id="CustomerSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">得意先選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>得意先ID</th><td><input type="text" v-model="customerId"/></td>
              <th>得意先名称</th><td><input type="text" v-model="customerName"/></td>
              <th>営業所</th>
              <td>
                <select v-model="salesOfficeCode">
                  <option v-for="salesOffice in salesOfficeList" :value="salesOffice.code" :key="salesOffice.code">{{ salesOffice.name }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="customerId" label="得意先ID" width="100" centered>{{props.row.customerId }}</b-table-column>
              <b-table-column field="customerName" label="得意先名称" width="300" >{{props.row.customerName}}</b-table-column>
              <b-table-column field="office" label="担当営業所" width="250" >{{props.row.salesOfficeCode | officeFilter(salesOfficeList)}}</b-table-column>
              <b-table-column field="address" label="住所" width="400" >{{props.row.address}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerSelectModal",
  props: {
    allowBlank:{type:Boolean, default: false, },
  },
  methods: {
    save: function() {
      if(this.selectedItem.isRegistered){
        this.$dialog.confirm({
          title: "　",
          confirmText:"はい",
          cancelText: "キャンセル",
          message:
            "得意先/請求先は他施設で既に使用済みです。登録しますか？",
          cancelConfirm: () => {
            return;
          },
          onConfirm: () => {
            // let _this = this;
            this.$emit('select', this.selectedItem);
            this.$parent.close();
          }
        });
      }else{
        this.$emit('select', this.selectedItem);
        this.$parent.close();
      }
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCustomerListPOST({
            body:{
              customerId: _this.customerId,
              customerName:  _this.customerName,
              salesOfficeCode: _this.salesOfficeCode,
            }
          });
        },
        async function(result){
          if(_this.allowBlank){
            result.obj.unshift({
              customerId: "",
              customerName: "",
              salesOfficeCode: "",
              address:""
            });
          }
          if(result.obj.length < 1){
            _this.showMessage('該当する得意先は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
  },
  data() {
    var salesOfficeList = this.getSalesOfficeMaster();
    salesOfficeList.unshift({});
    return {
      data: [],
      salesOfficeList,
      customerId: "",
      customerName: "",
      salesOfficeCode:"",
      selectedItem:"",
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/CustomerSelectModal.vue